import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import PropTypes from 'prop-types';
import * as React from 'react';
import { useLegacyPopoverContext } from './legacy-popover.context.js';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';
import { RenderComp } from '../../../react/components/core/render-comp.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {
  /**
  * Whether or not the popover is a dialog
  */
  dialog: PropTypes.bool,

  /**
  * Some localized value for the label
  */
  labelText: PropTypes.string,

  /**
  * Whether or not to remove the padding around the content
  */
  fullBleed: PropTypes.bool,

  /**
  * Hides the tooltip arrow
  */
  hideArrow: PropTypes.bool
};
var propKeysToRemove = Object.keys(propTypes);
var POPOVER_REQUIRED_SPACE_HORIZONTAL = 375;
var POPOVER_REQUIRED_SPACE_VERTICAL = 200;

function getTopOrBottom(position, triggerDomRect) {
  if (position === 'top' && triggerDomRect.y > POPOVER_REQUIRED_SPACE_VERTICAL) {
    return 'swan-legacy-popover-position-top';
  }

  if (position === 'bottom' && window.innerHeight - triggerDomRect.bottom > POPOVER_REQUIRED_SPACE_VERTICAL) {
    return 'swan-legacy-popover-position-bottom';
  }

  if (position === 'top') {
    return 'swan-legacy-popover-position-bottom';
  }

  return 'swan-legacy-popover-position-top';
}

function getHorizontalAlignment(position, triggerDomRect) {
  var triggerCenterX = triggerDomRect.left + triggerDomRect.width / 2;
  var posClassName = getTopOrBottom(position, triggerDomRect);
  var contentCenterX = POPOVER_REQUIRED_SPACE_HORIZONTAL / 2;

  if (triggerCenterX < contentCenterX) {
    return [posClassName, 'swan-legacy-popover-position-align-left', 'swan-legacy-popover-hide-arrow'];
  }

  if (window.innerWidth - triggerCenterX < contentCenterX) {
    return [posClassName, 'swan-legacy-popover-position-align-right', 'swan-legacy-popover-hide-arrow'];
  }

  return [posClassName];
}

function getClassNamesForPopoverPosition(launcherRef, position) {
  var _launcherRef_current;

  var launcherRectangle = launcherRef === null || launcherRef === void 0 ? void 0 : (_launcherRef_current = launcherRef.current) === null || _launcherRef_current === void 0 ? void 0 : _launcherRef_current.getBoundingClientRect(); // const refRectangle = ref?.current?.getBoundingClientRect()

  if (!launcherRectangle) return ["swan-legacy-popover-position-".concat(position)];

  switch (position) {
    case 'left':
      if (launcherRectangle.left > POPOVER_REQUIRED_SPACE_HORIZONTAL) {
        return ['swan-legacy-popover-position-left'];
      }

      return getHorizontalAlignment('top', launcherRectangle);

    case 'right':
      if (window.innerWidth - launcherRectangle.right > POPOVER_REQUIRED_SPACE_HORIZONTAL) {
        return ['swan-legacy-popover-position-right'];
      }

      return getHorizontalAlignment('top', launcherRectangle);

    case 'top':
    case 'bottom':
      return getHorizontalAlignment(position, launcherRectangle);

    default:
      return [];
  }
}
/**
 * @deprecated Use new Popover and its sub-components instead
 */


var LegacyPopoverContent = renderWithRef('LegacyPopoverContent', propTypes, function (props, ref) {
  var dialog = props.dialog,
      labelText = props.labelText,
      fullBleed = props.fullBleed,
      _props$hideArrow = props.hideArrow,
      hideArrow = _props$hideArrow === void 0 ? false : _props$hideArrow,
      children = props.children;

  var _useLegacyPopoverCont = useLegacyPopoverContext(),
      expanded = _useLegacyPopoverCont.expanded,
      position = _useLegacyPopoverCont.position,
      launcherRef = _useLegacyPopoverCont.launcherRef;

  var accessibilityProps = dialog ? {
    role: 'dialog',
    'aria-modal': true
  } : {
    role: 'tooltip'
  };
  var classNameSet = new Set(['swan-legacy-popover'].concat(_toConsumableArray(getClassNamesForPopoverPosition(launcherRef, position))));
  if (hideArrow) classNameSet.add('swan-legacy-popover-hide-arrow');
  if (fullBleed) classNameSet.add('swan-legacy-popover-skin-full-bleed');
  return expanded ? /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    classNames: classNameSet,
    propKeysToRemove: propKeysToRemove,
    props: _object_spread({}, props, accessibilityProps),
    "aria-expanded": expanded,
    "aria-label": labelText
  }, children) : null;
});
LegacyPopoverContent.defaultProps = {
  dialog: false,
  labelText: '',
  fullBleed: false
};
export { LegacyPopoverContent };